import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 }, variant: String }

  connect() {
    if (this.variantValue === "alert") console.error(this.element.textContent.trim())

    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    clearTimeout(this.timeout)
    this.element.classList.add("opacity-0", "transition-opacity", "duration-200")
    setTimeout(() => this.element.remove(), 200)
  }
}
